/*global google*/

import _ from 'lodash';

export function fitToOrders(bounds, orders, gMap, recipients, pickUpPoints) {
  _.forEach(orders, (order) => {
    let recipient = _.find(recipients, {id: order.recipientId});
    if(recipient && recipient.gpsLocation)
      bounds.extend(new window.google.maps.LatLng(recipient.gpsLocation.lat, recipient.gpsLocation.lng));
    _.forEach(order.items, (item) => {
      let point = _.find(pickUpPoints, {id: item.pickupPointId});
      if(point)
        bounds.extend(new window.google.maps.LatLng(point.gpsLocation.lat, point.gpsLocation.lng));
    });
    if (gMap) {
      gMap.fitBounds(bounds);
    }
  });
}

export function fitToDriver(bounds, drivers, gMap) {
  _.forEach(drivers, (driver) => {
    bounds.extend(new window.google.maps.LatLng(driver.gpsLocation.lat, driver.gpsLocation.lng));
    if (gMap) {
      gMap.fitBounds(bounds);
    }
  });
}

export function fitToTeam(markers, polygonFromTeam) {
  var bounds = new window.google.maps.LatLngBounds();
  _.forEach(polygonFromTeam, (m) => {
    bounds.extend(new window.google.maps.LatLng(m.lat, m.lng));
  });

  let polyPoints = [];
  _.forEach(polygonFromTeam, (point) => {
    polyPoints.push(new google.maps.LatLng(point.lat, point.lng));
  });

  var polygon = new google.maps.Polygon({paths: polyPoints});
    _.forEach(markers, (marker) => {
      if(marker && marker.position) {
        let point = new google.maps.LatLng(marker.position.lat, marker.position.lng);

      if (google.maps.geometry && !google.maps.geometry.poly.containsLocation(point, polygon)) {
        marker.hide = true;
        }
      }
  });
}


// WEBPACK FOOTER //
// ./src/utils/fitToBounds.js